<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReportTracingAbilityDetails"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
											<app-input-combobox-autocomplete :options="filterControlCardIds" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Control Card Id " id="filter-" size="sm" :model.sync="filter.filterControlCardId" @input="getFilterControlCardIds" @focus="getFilterControlCardIds" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportTracingAbilityDetails"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report Tracing Ability Detail</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-reporttracingabilitydetail" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="light" :bordered="true" :no-local-sorting="true" :items="reportTracingAbilityDetails" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="reportTracingAbilityDetails.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
										<b-th stacked-heading="Material Source" class="table-filter">
					<b-form-input id="input-material-source-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.materialSource" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part Number" class="table-filter">
					<b-form-input id="input-part-number-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.partNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Control Card Destination" class="table-filter">
					<b-form-input id="input-control-card-destination-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.controlCardDestination" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Lot No" class="table-filter">
					<b-form-input id="input-lot-no-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.lotNo" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="WOP Number" class="table-filter">
					<b-form-input id="input-wop-number-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.wopNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Production Date" class="table-filter">
					<b-form-input id="input-production-date-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.productionDate" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="FInish Production Date" class="table-filter">
					<b-form-input id="input-finish-production-date-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.finishProductionDate" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Machine" class="table-filter">
					<b-form-input id="input-machine-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.machine" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Operator User" class="table-filter">
					<b-form-input id="input-operator-user-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.operatorUser" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Shift" class="table-filter">
					<b-form-input id="input-shift-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.shift" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Before" class="table-filter">
					<b-form-input id="input-qty-before-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.qtyBefore" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty After" class="table-filter">
					<b-form-input id="input-qty-after-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.qtyAfter" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Taken" class="table-filter">
					<b-form-input id="input-qty-taken-table" @input="getReportTracingAbilityDetailsWithoutLoading" v-model="filter.qtyTaken" size="sm"></b-form-input>
				</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>
					
					
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-control-card-destination" label-cols-lg="12"  label="Control Card Destination" label-for="input-control-card-destination" size="sm" :model.sync="row.item.controlCardDestination"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-lot-no" label-cols-lg="12"  label="Lot No" label-for="input-lot-no" size="sm" :model.sync="row.item.lotNo"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-wop-number" label-cols-lg="12"  label="WOP Number" label-for="input-wop-number" size="sm" :model.sync="row.item.wopNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-production-date" label-cols-lg="12"  label="Production Date" label-for="input-production-date" size="sm" :model.sync="row.item.productionDate"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-finish-production-date" label-cols-lg="12"  label="FInish Production Date" label-for="input-finish-production-date" size="sm" :model.sync="row.item.finishProductionDate"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-machine" label-cols-lg="12"  label="Machine" label-for="input-machine" size="sm" :model.sync="row.item.machine"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-operator-user" label-cols-lg="12"  label="Operator User" label-for="input-operator-user" size="sm" :model.sync="row.item.operatorUser"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-shift" label-cols-lg="12"  label="Shift" label-for="input-shift" size="sm" :model.sync="row.item.shift"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-before" label-cols-lg="12"  label="Qty Before" label-for="input-qty-before" size="sm" :model.sync="row.item.qtyBefore"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-after" label-cols-lg="12"  label="Qty After" label-for="input-qty-after" size="sm" :model.sync="row.item.qtyAfter"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-taken" label-cols-lg="12"  label="Qty Taken" label-for="input-qty-taken" size="sm" :model.sync="row.item.qtyTaken"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
											  v-model="currentPage"
											  :total-rows="(reportTracingAbilityDetailsPaging != null ? reportTracingAbilityDetailsPaging.dataCount : 0)"
											  :per-page="(reportTracingAbilityDetailsPaging != null ? reportTracingAbilityDetailsPaging.pageSize : 0)"
											  aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-reporttracingabilitydetail.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reporttracingabilitydetail.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ReportTracingAbilityDetail from '@/models/ReportTracingAbilityDetail/ReportTracingAbilityDetail';
import ReportTracingAbilityDetailList from '@/models/ReportTracingAbilityDetail/ReportTracingAbilityDetailList';
import ReportTracingAbilityDetailFilter from '@/filters/ReportTracingAbilityDetail/ReportTracingAbilityDetailFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
export default {
	components : {
		ReportTracingAbilityDetail, 
		ReportTracingAbilityDetailList, 
		ReportTracingAbilityDetailFilter, 
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"materialSource": {}, "class" : "th-material-source first-child", "label" : "Material Source", key: 'materialSource', }, 
				{"partNumber": {}, "class" : "th-part-number", "label" : "Part Number", key: 'partNumber', }, 
				{"controlCardDestination": {}, "class" : "th-control-card-destination last-child", "label" : "Control Card Destination", key: 'controlCardDestination', }, 
				{"lotNo": {}, "class" : "th-lot-no d-stack-none", "label" : "Lot No", key: 'lotNo', }, 
				{"wopNumber": {}, "class" : "th-wop-number d-stack-none", "label" : "WOP Number", key: 'wopNumber', }, 
				{"productionDate": {}, "class" : "th-production-date d-stack-none", "label" : "Production Date", key: 'productionDate', }, 
				{"finishProductionDate": {}, "class" : "th-finish-production-date d-stack-none", "label" : "FInish Production Date", key: 'finishProductionDate', }, 
				{"machine": {}, "class" : "th-machine d-stack-none", "label" : "Machine", key: 'machine', }, 
				{"operatorUser": {}, "class" : "th-operator-user d-stack-none", "label" : "Operator User", key: 'operatorUser', }, 
				{"shift": {}, "class" : "th-shift d-stack-none", "label" : "Shift", key: 'shift', }, 
				{"qtyBefore": {}, "class" : "th-qty-before d-stack-none", "label" : "Qty Before", key: 'qtyBefore', }, 
				{"qtyAfter": {}, "class" : "th-qty-after d-stack-none", "label" : "Qty After", key: 'qtyAfter', }, 
				{"qtyTaken": {}, "class" : "th-qty-taken d-stack-none", "label" : "Qty Taken", key: 'qtyTaken', }, 

			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportTracingAbilityDetails: [],
			reportTracingAbilityDetailsPaging: {},
			filterControlCardIds : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
		}
	},	methods : {
		getReportTracingAbilityDetails : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportTracingAbilityDetail.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportTracingAbilityDetails = result.data
					this.reportTracingAbilityDetailsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportTracingAbilityDetailsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportTracingAbilityDetail.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportTracingAbilityDetails = result.data
					this.reportTracingAbilityDetailsPaging = result
				}
			})
			.catch(error => {});
		},
		getFilterControlCardIds : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportTracingAbilityDetail.getListCustomUrl(this,'getlistfiltercontrolcardid' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterControlCardIds = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReportTracingAbilityDetailFilter();
			this.getReportTracingAbilityDetails();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportTracingAbilityDetails();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportTracingAbilityDetail.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportTracingAbilityDetail.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportTracingAbilityDetail.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportTracingAbilityDetail.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportTracingAbilityDetails();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportTracingAbilityDetail.deleteMultipleData(this).then(result => {
					this.getReportTracingAbilityDetails();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportTracingAbilityDetailParent = document.getElementById('table-list-reporttracingabilitydetail').parentNode;
			tableReportTracingAbilityDetailParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportTracingAbilityDetailParent.scrollWidth - tableReportTracingAbilityDetailParent.offsetWidth) == Math.ceil(tableReportTracingAbilityDetailParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportTracingAbilityDetailParent = document.getElementById('table-list-reporttracingabilitydetail').parentNode;
			tableReportTracingAbilityDetailParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportTracingAbilityDetailParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportTracingAbilityDetailFilter();
		this.getFilterControlCardIds()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report Tracing Ability Detail"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportTracingAbilityDetails();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportTracingAbilityDetails();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportTracingAbilityDetails();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportTracingAbilityDetails();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportTracingAbilityDetails();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportTracingAbilityDetail.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reporttracingabilitydetailindex") {
					this.getReportTracingAbilityDetailsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_tracing_ability_detail").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
